/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Tab_Next_TasksInputs */

const en_task_flow_tab_next_tasks = /** @type {(inputs: Task_Flow_Tab_Next_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next activities`)
};

const pt_br2_task_flow_tab_next_tasks = /** @type {(inputs: Task_Flow_Tab_Next_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximas atividades`)
};

/**
* | output |
* | --- |
* | "Next activities" |
*
* @param {Task_Flow_Tab_Next_TasksInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_tab_next_tasks = /** @type {((inputs?: Task_Flow_Tab_Next_TasksInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Tab_Next_TasksInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_tab_next_tasks(inputs)
	return pt_br2_task_flow_tab_next_tasks(inputs)
});